import {Divider} from '@material-ui/core'
import ReportsEditList from 'modules/reports/components/Edit/List'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsEditFilters.styles'

type Props = {}

function ReportsEditFilters(props: Props) {
  const classes = useStyles()
  const {p} = useCore('reports', 'components', 'EditFilters')

  const items = [{}, {}, {}, {}]

  return (
    <div className={classes.root} data-testid={p()}>
      <ReportsEditList items={items} data-testid={p('0')} />
      <Divider />
      <ReportsEditList items={items} data-testid={p('1')} />
    </div>
  )
}

export default ReportsEditFilters
